import React from "react";
import { PageHero, FadeUp } from "../../components/public/Section";
import { Milestone } from "lucide-react";

const TIMELINE = [
  ["1983", "Foundation of GOS", "Founded by a small group of ophthalmologists dedicated to advancing eye care in Ghaziabad."],
  ["1990", "First Chapter Meeting", "The first annual chapter meeting brought together members from across the region."],
  ["1995", "Annual Conference Launch", "GOS Annual Scientific Conference became a landmark academic event."],
  ["2005", "Structured CME", "Regular CME programs institutionalized for members and residents."],
  ["2010", "Community Outreach", "Signature eye-camp initiatives launched in underserved areas."],
  ["2015", "Fellowship Programs", "Formal support for fellowships in cornea, retina and glaucoma."],
  ["2020", "Digital Learning", "Online CMEs and webinars introduced for continuous learning."],
  ["2023", "Four Decades", "Celebrating 40 years of dedicated service to ophthalmology."],
];

export default function History() {
  return (
    <div>
      <PageHero title="Our History" subtitle="Four decades of dedication to eye care, education and community service." breadcrumbs={["Home", "About", "History"]} />
      <section className="section container-page">
        <div className="relative">
          <div className="absolute left-4 top-0 bottom-0 w-px bg-brand-border" />
          <div className="space-y-8">
            {TIMELINE.map(([y, t, d]) => (
              <FadeUp key={y} className="relative pl-14">
                <div className="absolute left-0 top-1 w-8 h-8 rounded-full bg-brand-primary text-white flex items-center justify-center shadow-md"><Milestone size={14} /></div>
                <div className="text-brand-primary font-serif text-2xl font-bold">{y}</div>
                <div className="font-semibold text-brand-text mt-1">{t}</div>
                <div className="text-brand-muted text-sm mt-2 max-w-2xl">{d}</div>
              </FadeUp>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
